export default __webpack_public_path__ + "static/media/maxine_detail3.bc071c50.jpg";